import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialougeComponent } from '@app/auth/confirm-dialouge/confirm-dialouge.component';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { TeamMember } from '../../models/TeamMember';
import { TeamService } from '../../services/team/team.service';
import { PermissionComponent } from '../permission/permission.component';
import { TeamInviteComponent } from '../team-invite/team-invite.component';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.css']
})
export class TeamComponent implements OnInit {

  companyMembers: any[] = [];
  invitedMembers: any[] = [];
  hasCompany: boolean = false;
  companyId: string = null;
  loggedInUserRole = localStorage.getItem('role')
  constructor(private dialog: MatDialog, private teamService: TeamService, private loaderService: LoaderService,
    private notificationService: NotificationService, private errorhandlerService: ErrorhandlerService) { }

  ngOnInit() {
    this.companyId = localStorage.getItem('companyId');
    if (this.companyId != undefined && this.companyId != '' && this.companyId != null && this.companyId != 'null')
      this.hasCompany = true;

    this.fn_getCompanyMembers(this.companyId);
    this.fn_getInvitedMembers(this.companyId);
  }
  fn_getCompanyMembers(companyId) {
    this.loaderService.show();
    this.teamService.getCompanyMembers(parseInt(companyId))
      .subscribe((res: any) => {
        if (res.StatusCode === 200) {
          this.companyMembers = res.Data.ResponseData;
        } else
          this.notificationService.error(res.Message, 'Try Again');

        this.loaderService.hide();
      }, err => {
        this.loaderService.hide();
        this.errorhandlerService.handleError(err);
      });
  }
  GetAllPermissions(userId: number) {
    const dialogRef = this.dialog.open(PermissionComponent, {
      disableClose: false,
      data: { UserId: userId, ReInvite: false },
      height: '500px',
      width: '600px'
    });
  }
  fn_getInvitedMembers(companyId) {
    this.loaderService.show();
    this.teamService.getInvitedMembers(parseInt(companyId))
      .subscribe((res: any) => {
        if (res.StatusCode === 200) {
          this.invitedMembers = res.Data.ResponseData;
        } else
          this.notificationService.error(res.Message, 'Record(s)');

        this.loaderService.hide();
      }, err => {
        this.loaderService.hide();
        this.errorhandlerService.handleError(err);
      });
  }

  deactivateUser(userId) {
    this.loaderService.show();
    this.teamService.deactivateUser(userId)
      .subscribe((res: any) => {
        if (res.StatusCode === 200) {
          this.fn_getCompanyMembers(this.companyId);
        } else
          this.notificationService.error(res.Message, 'Record(s)');

        this.loaderService.hide();
      }, err => {
        this.loaderService.hide();
        this.errorhandlerService.handleError(err);
      });
  }

  openDialog(userId) {
    var text = "Are you sure want to remove this user ?";
    const dialog = this.dialog.open(ConfirmDialougeComponent, {
      width: '400px',
      height: '300px',
      data: { Title: "Confirm Remove", Description: text, removeUser: true }
    });
    dialog.afterClosed().subscribe((res: any) => {
      if (res != "" && res != null && res == true) {
        this.loaderService.show();
        this.teamService.deleteUser(userId)
          .subscribe((res: any) => {
            if (res.StatusCode === 200) {
              this.fn_getCompanyMembers(this.companyId);
            } else
              this.notificationService.error(res.Message, 'Record(s)');

            this.loaderService.hide();
          }, err => {
            this.loaderService.hide();
            this.errorhandlerService.handleError(err);
          });
      }
    });
  }

  deleteUser(userId) {
    this.openDialog(userId);
  }

  sendInvite(role, email) {
    if (role == 'Owner') {
      let payload: TeamMember = {
        Email: email,
        CompanyId: parseInt(localStorage.getItem('companyId')),
        Role: role == 'Owner' ? 'owner' : 'staff',
        Permission: []
      }
      this.loaderService.show();
      this.teamService.sendInvite(payload)
        .subscribe((res: any) => {
          if (res.StatusCode === 200) {
            this.fn_getInvitedMembers(this.companyId);
            this.notificationService.success('Invitation sent.', 'Success')
            this.loaderService.hide();
          } else
            this.notificationService.error(res.Message, 'Record(s)');

          this.loaderService.hide();
        }, err => {
          this.loaderService.hide();
          this.errorhandlerService.handleError(err);
        });
    } else {
      const dialogRef = this.dialog.open(PermissionComponent, {
        disableClose: false,
        data: { UserId: null, Email: email, ReInvite: true },
        height: '500px',
        width: '600px'
      });
      dialogRef.afterClosed().subscribe(result => {
        this.fn_getInvitedMembers(this.companyId);
      });
    }
  }
}
